import '../../core/components/app-root/AppRoot.css';
import './Header.css';
export var header = '_150dima0-3-15-1';